import { useController, UseControllerProps, useFormContext } from 'react-hook-form';

import { SuggestionsInput, SuggestionsInputProps } from '../SuggestionsInput';

type Props = Omit<SuggestionsInputProps, 'onChange' | 'errorMessage'> & {
  name: UseControllerProps['name'];
  rules?: UseControllerProps['rules'];
  defaultValue?: UseControllerProps['defaultValue'];
};

export const SuggestionsInputControlled = ({ name, defaultValue = '', rules, ...rest }: Props) => {
  const { control } = useFormContext();

  const {
    field: { onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return <SuggestionsInput {...rest} errorMessage={error?.message} onChange={onChange} />;
};
